import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import type { SaveQuoteMetadataParameters } from './types'
import { EXTERNAL_DOMAIN } from 'core/constants/endpoints'

function saveQuoteMetadata({ agentId, ...data }: SaveQuoteMetadataParameters) {
  const url = `${EXTERNAL_DOMAIN}/v1/savequote/agent/${agentId}/quote`

  return fetchJSONHandleError({
    url,
    data
  })
}

export default saveQuoteMetadata
